import { Editor, Element, Transforms } from 'slate'

import { isBlockTypeActive } from './isBlockTypeActive.js'
import { LIST_TYPES } from './listTypes.js'
import { TEXT_ALIGN_TYPES } from './textAlignTypes.js'

export function toggleBlock (editor, format) {
  const isActive = isBlockTypeActive(
    editor,
    format,
    TEXT_ALIGN_TYPES.includes(format)
      ? 'align'
      : 'type'
  )

  const isList = LIST_TYPES.includes(format)

  Transforms.unwrapNodes(editor, {
    match: n => (
      !Editor.isEditor(n) &&
      Element.isElement(n) &&
      LIST_TYPES.includes(n.type) &&
      !TEXT_ALIGN_TYPES.includes(format)
    ),

    split: true
  })

  const newProperties = TEXT_ALIGN_TYPES.includes(format)
    ? {
      align: isActive
        ? undefined
        : format
    }
    : {
      type: isActive
        ? 'paragraph'
        : isList
          ? 'list-item'
          : format
    }

  Transforms.setNodes(editor, newProperties)

  if (!isActive && isList) {
    const block = {
      type: format,
      children: []
    }

    Transforms.wrapNodes(editor, block)
  }
}
